import React from 'react';

// Small inline-SVG glyphs shared between the Docs & repo empty states and the
// filled rows so the icon is identical in both places. Minimal, strokeWidth
// ~1.75, stroke currentColor, fill none — caller sets color/size.

export function DocGlyph({ size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M4 2h5l3 3v9H4V2Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
      <path
        d="M9 2v3h3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function RepoGlyph({ size = 14 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      aria-hidden="true"
      style={{ flexShrink: 0 }}
    >
      <circle cx="4" cy="4" r="1.75" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="4" cy="12" r="1.75" stroke="currentColor" strokeWidth="1.75" />
      <circle cx="12" cy="4" r="1.75" stroke="currentColor" strokeWidth="1.75" />
      <path
        d="M4 5.75v4.5M12 5.75c0 2.5-2 3.5-4 3.5"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
}
